import { isValid, parse } from 'date-fns'
import { IDataQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { formatRange } from '../../../../../../generic/ui/DatePicker/formatRange'
import { ReportDateRange, ReportFieldKey, ReportRow } from '../types/row'

export const REPORT_FIELD_KEYS: ReportFieldKey[] = [
  'Field1',
  'Field2',
  'Field3',
  'Field4',
  'Field5',
  'Field6',
  'Field7',
]

// Desc wins; an empty desc falls back to the raw id (same rule as the Excel export).
const toLabel = (item: IDataQ4, key: ReportFieldKey): string =>
  item[`${key}_Desc`]?.trim() || String(item[key])

// yyyyMMdd → Date; an empty or malformed value yields null so formatRange never sees an Invalid Date.
const parseYmd = (value: string): Date | null => {
  const date = parse(value, 'yyyyMMdd', new Date())
  return isValid(date) ? date : null
}

export const toReportRows = (data: IDataQ4[]): ReportRow[] =>
  data.map((item, index) => {
    const labels = Object.fromEntries(
      REPORT_FIELD_KEYS.map((key) => [`${key}_Label`, toLabel(item, key)]),
    ) as Pick<ReportRow, `${ReportFieldKey}_Label`>

    return {
      ...item,
      ...labels,
      rowId: index,
      PricePerKg: item.Price && item.Weight ? item.Price / item.Weight : null,
    }
  })

/** Applied report range in the DateRangePicker format; '' when there is no valid range. */
export const formatReportRange = (range: ReportDateRange | null): string =>
  range ? formatRange(parseYmd(range.from), parseYmd(range.to)) : ''
